import React from "react"
import { Box, BoxProps, Fade, SpinnerProps } from "@chakra-ui/react"

import Spinner from "components/Spinner"

type FullSpinnerProps = {
  in?: boolean
  fadeStyle?: React.CSSProperties
  boxProps?: BoxProps
  spinnerProps?: SpinnerProps
}
const FullSpinner = (props: FullSpinnerProps) => {
  return (
    <Fade
      in={typeof props?.in === "undefined" ? true : props.in}
      transition={{ exit: { delay: 0.4 }, enter: { duration: 0.4 } }}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        ...props.fadeStyle,
      }}>
      <Box
        w="100%"
        h="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p="0"
        {...props.boxProps}>
        <Spinner {...props.spinnerProps} />
      </Box>
    </Fade>
  )
}

export default FullSpinner
